import React from 'react';
import { branch, compose } from 'recompose';
import renderComponent from 'recompose/renderComponent';
import { get, map } from 'lodash';
import Money from './money';
import * as shapes from './shapes';
import Hours from './Hours';

const SpanCell = ({ children }) => (<span>{children}</span>);
SpanCell.propTypes = { children: shapes.childrenOrValue };
SpanCell.defaultProps = { children: null };
const MoneyCell = ({ children }) => (<Money>{children}</Money>);
MoneyCell.propTypes = { children: shapes.childrenOrValue };
MoneyCell.defaultProps = { children: null };
const ArrayCell = ({ children }) => (
  <SpanCell>
    {map(children, child => (<div>{child}</div>))}
  </SpanCell>
);
ArrayCell.propTypes = { children: shapes.childrenOrValue };
ArrayCell.defaultProps = { children: null };
const HoursCell = ({ children }) => (
  <SpanCell>
    <Hours>{children}</Hours>
  </SpanCell>
);
HoursCell.propTypes = { children: shapes.childrenOrValue };
HoursCell.defaultProps = { children: null };


const regex = /(price|revenue|POS|Cash|Squire|Total|Due|Taxes|TaxAmount|Tips|Fees|Gift|Card|Transferred to Barber|Transferred to Shop|GC)/i;
const hoursRegexp = /hours/i;

const TableCell = compose(
    branch(
        props => regex.test(get(props, 'column', '')),
        renderComponent(MoneyCell),
    ),
    branch(
        props => Array.isArray(get(props, 'children', '')),
        renderComponent(ArrayCell),
    ),
    branch(
        props => hoursRegexp.test(get(props, 'column', '')),
        renderComponent(HoursCell),
    ),
)(SpanCell);

export default TableCell;
